import request from '../request';

// 通用文件上传
export function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', 'image');
  return request({
    url: '/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
